import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';
import { AuthProvider } from './sections/auth/AuthContext'

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
    <ToastContainer position="top-right" autoClose={2000} />
      <AuthProvider>
        <ScrollTop>
        <RouterProvider router={router} />
      </ScrollTop>
      </AuthProvider>
    </ThemeCustomization>
  );
}
